import { render } from "./HeaderBorderButton.vue?vue&type=template&id=ab67f7b4&scoped=true"
import script from "./HeaderBorderButton.vue?vue&type=script&lang=js"
export * from "./HeaderBorderButton.vue?vue&type=script&lang=js"

import "./HeaderBorderButton.vue?vue&type=style&index=0&id=ab67f7b4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab67f7b4"]])

export default __exports__